import { render, staticRenderFns } from "./menu-symbol.vue?vue&type=template&id=94ac88c6&scoped=true"
import script from "./menu-symbol.vue?vue&type=script&lang=js"
export * from "./menu-symbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ac88c6",
  null
  
)

export default component.exports